import script from "./CreatePost.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePost.vue?vue&type=script&setup=true&lang=js"

import "./CreatePost.vue?vue&type=style&index=0&id=41f29770&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f29770"]])

export default __exports__